import * as ActionTypes from '../ActionTypes';

export const GetFormTemplateAction = (params) => {
    return {
        type: ActionTypes.FORM_TEMPLATE_GET_REQUEST,
        params
    }
}


export const AddFormTemplateAction = (params) => {
    return {
        type: ActionTypes.FORM_TEMPLATE_ADD_REQUEST,
        params
    }
}

export const UpdateFormTemplateAction = (params) => {
    return {
        type: ActionTypes.FORM_TEMPLATE_UPDATE_REQUEST,
        params
    }
}

export const DeleteFormTemplateAction = (params) => {
    return {
        type: ActionTypes.FORM_TEMPLATE_DELETE_REQUEST,
        params
    }
}

//Pre Screen Questions

export const GetPreScreenTemplateAction = (params, callback) => {
    return {
        type: ActionTypes.PRE_SCREEN_TEMPLATE_GET_REQUEST,
        params,
        callback
    }
}


export const AddPreScreenTemplateAction = (params, callback) => {
    return {
        type: ActionTypes.PRE_SCREEN_TEMPLATE_ADD_REQUEST,
        params,
        callback
    }
}

export const UpdatePreScreenTemplateAction = (params) => {
    return {
        type: ActionTypes.PRE_SCREEN_TEMPLATE_UPDATE_REQUEST,
        params
    }
}

export const DeletePreScreenTemplateAction = (params) => {
    return {
        type: ActionTypes.PRE_SCREEN_TEMPLATE_DELETE_REQUEST,
        params
    }
}

//Offer Letter

export const GetOfferLetterTemplateAction = (params) => {
    return {
        type: ActionTypes.OFFER_LETTER_TEMPLATE_GET_REQUEST,
        params
    }
}

export const AddOfferLetterTemplateAction = (params) => {
    return {
        type: ActionTypes.OFFER_LETTER_TEMPLATE_ADD_REQUEST,
        params
    }
}

export const UpdateOfferLetterTemplateAction = (params) => {
    return {
        type: ActionTypes.OFFER_LETTER_TEMPLATE_UPDATE_REQUEST,
        params
    }
}

export const DeleteOfferLetterTemplateAction = (params) => {
    return {
        type: ActionTypes.OFFER_LETTER_TEMPLATE_DELETE_REQUEST,
        params
    }
}

// offer letter response

export const GetOfferLetterTemplateResponseAction = (params,callback) => {
    return {
        type: ActionTypes.OFFER_LETTER_TEMPLATE_RESPONSE_GET_REQUEST,
        params,
        callback
    }
}

export const AddOfferLetterTemplateResponseAction = (params,callback) => {
    return {
        type: ActionTypes.OFFER_LETTER_TEMPLATE_RESPONSE_ADD_REQUEST,
        params,
        callback
    }
}

export const UpdateOfferLetterTemplateResponseAction = (params,callback) => {
    return {
        type: ActionTypes.OFFER_LETTER_TEMPLATE_RESPONSE_UPDATE_REQUEST,
        params,
        callback
    }
}
